import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import '../App.css';

const grade_class = (grade) => {
	return 'review-grade review-grade-' + grade.toLowerCase();
};

const render_loading = () => {
	return (
		<div className="review-loading">
			<Spinner animation="border" />
			<p className="review-loading-text">Coach is reviewing your call...</p>
		</div>
	);
};

const render_upgrade = () => {
	return (
		<div className="review-upgrade">
			<p className="review-upgrade-text">AI Coach Review is available on the Pro plan and above.</p>
			<p className="review-upgrade-subtext">Please upgrade your plan to unlock detailed call reviews and grading.</p>
		</div>
	);
};

const render_grade = (review) => {
	return (
		<div className="review-grade-section">
			<div className={grade_class(review.grade)}>
				{review.grade}
			</div>
			<div className="review-percentage">
				{review.percentage}%
			</div>
		</div>
	);
};

const render_stats = (review) => {
	return (
		<div className="review-stats">
			<div className="review-stat">
				<span className="review-stat-value">{review.successful_responses}</span>
				<span className="review-stat-label">Successful 3A Responses</span>
			</div>
			<div className="review-stat-divider">/</div>
			<div className="review-stat">
				<span className="review-stat-value">{review.total_challenges}</span>
				<span className="review-stat-label">Total Challenges</span>
			</div>
		</div>
	);
};

const render_summary = (review) => {
	const paragraphs = review.summary.split('\n\n').filter(p => p.trim());

	return (
		<div className="review-summary">
			{paragraphs.map((p, i) => (
				<p key={i}>{p.trim()}</p>
			))}
		</div>
	);
};

const render_body = (review, loading, has_coach_review) => {
	if(!has_coach_review) {
		return render_upgrade();
	}
	if(loading) {
		return render_loading();
	}
	if(!review) {
		return null;
	}
	return (
		<React.Fragment>
			{render_grade(review)}
			{render_stats(review)}
			{render_summary(review)}
		</React.Fragment>
	);
};

function ReviewModal({ show, on_hide, review, loading, has_coach_review }) {
	return (
		<Modal show={show} onHide={on_hide} centered>
			<Modal.Header closeButton>
				<Modal.Title>Coach Review</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{render_body(review, loading, has_coach_review)}
			</Modal.Body>
			<Modal.Footer>
				<Button variant="primary" onClick={on_hide}>Close</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default ReviewModal;
